import {Alert, Box, Button, Link, Snackbar, Typography} from "@mui/material"
import {DateTime} from "luxon"
import {FC} from "react"
import {ClimbingEvent, ClimbingEventGroup} from "../../../models/ClimbingEvent"
import {dateTimeAsString} from "../../../services/time/TimeService"
import {useTranslation} from "react-i18next";
import banner from "../../../images/banner.jpg"

type Props = {
    event: ClimbingEvent,
    menuElement: React.ReactElement,
    selectedGroup: ClimbingEventGroup | undefined,
    clicked: boolean,
    handleClose: () => void
}

export const CompetitionInfoComponent: FC<Props> = ({event, menuElement, selectedGroup, clicked, handleClose}) => {

    const {t} = useTranslation()
    if (!selectedGroup) {
        return <Typography variant="h6" align="center">{t('event.selectGroup')}</Typography>
    }

    const hasGroupStarted = DateTime.local().plus({minutes: 5}).toMillis() > selectedGroup.startDate
    const hasGroupEnded = DateTime.local().minus({minutes: 65}).toMillis() > selectedGroup.endDate

    return (
        <>
            {/* <Typography align="center" variant="h6" m={1}>{event.name}</Typography> */}
            <Box
                sx={{display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column", gap: 1}}>
                <img height={200} src={banner} alt={t('logo') || ""}/>
            </Box>
            {!hasGroupStarted &&
                <>
                    <Typography align="center" variant="h6"
                                m={1}> {t('event.groupWillStart')} : {dateTimeAsString(selectedGroup.startDate)} </Typography>
                    {clicked && <Snackbar open={clicked} autoHideDuration={6000} onClose={handleClose}>
                        <Alert severity="warning" sx={{width: '100%'}}>
                            {t('event.groupWillStart')} : {dateTimeAsString(selectedGroup.startDate)}
                        </Alert>
                    </Snackbar>}
                </>
            }
            {hasGroupEnded &&
                <>
                    <Typography align="center" variant="h6"
                                m={1}> {t('event.groupHaveEnded')} : {dateTimeAsString(selectedGroup.endDate)} </Typography>
                    {clicked && <Snackbar open={clicked} autoHideDuration={6000} onClose={handleClose}>
                        <Alert severity="warning" sx={{width: '100%'}}>
                            {t('event.groupHaveEnded')} : {dateTimeAsString(selectedGroup.endDate)}
                        </Alert>
                    </Snackbar>}
                </>
            }
            {hasGroupStarted && !hasGroupEnded &&
                (<>
                        {menuElement}
                    </>
                )}
            <Box sx={{display: "flex", justifyContent: "space-around", mb: 2, mt: 2}}>
                {event.moreInfoLink && <Link target="_blank" href={event.moreInfoLink}>{t('event.moreInfo')}</Link>}
            </Box>

            <Button variant="contained" color="primary" href={event.resultsLink}>
                {t('event.results')}
            </Button>

        </>

    )
}